export const fragmentTypes = {
  Game: [
    'RunbetGame',
    'StepbetGame',
    'DietbetGame',
    'FalkorGame',
    'QuitbetGame',
  ],
  Cloudinary: ['CloudinaryImage', 'CloudinaryVideo'],
  PlayerStatus: [
    'StepbetPlayerStatus',
    'DietbetPlayerStatus',
    'FalkorPlayerGameState',
    'QuitbetPlayerGameState',
  ],
  Round: ['QuitbetRound', 'FalkorRound'],
  GameSubround: ['QuitbetSubround', 'FalkorSubround'],
  Subround: ['QuitbetSubround', 'FalkorSubround'],
  Metric: [
    'Run',
    'QuitbetBreathMetric',
    'FalkorCaptionedPhotoMetric',
    'FalkorMediaMetric',
    'WorkoutMetric',
    'FalkorStepsMetric',
  ],
  Activity: [
    'FalkorCaptionedPhotoActivity',
    'FalkorCardioActivity',
    'FalkorMediaActivity',
    'FalkorMinPaceDistanceActivity',
    'FalkorMinPaceDurationActivity',
  ],
  GameRound: ['QuitbetRound', 'RunbetRound', 'FalkorRound'],
  PageInfo: ['KeysetPageInfo', 'OffsetPageInfo'],
  GameBoard: ['FalkorGameBoard', 'QuitbetGameBoard'],
  GameBoardPlayer: ['FalkorGameBoardPlayer', 'QuitbetGameBoardPlayer'],
  OrderItem: [
    'ChipsOrderItem',
    'GameBetOrderItem',
    'GameOrderItem',
    'MembershipOrderItem',
    'OpRegistrationFeeOrderItem',
    'OpSideBetOrderItem',
    'OpVirtualGiftsOrderItem',
    'OpWeighInTokensOrderItem',
    'PointsOrderItem',
    'PromoOrderItem',
  ],
  GameProfile: [
    'DietbetGameProfile',
    'FalkorGameProfile',
    'StepbetGameProfile',
  ],
  UserNotificationList: ['DietbetNotificationList', 'StepbetNotificationList'],
  MembershipOffer: ['StepbetMembershipOffer', 'DietbetMembershipOffer'],
  RepeatingGameSpecStartCadence: [
    'RepeatingGameSpecAfterPredecessorStartDateStartCadence',
  ],
  RepeatingGameSpecVisibilityCadence: [
    'RepeatingGameSpecBeforeStartDateVisibilityCadence',
  ],
  RunbetGameFactory: ['RunbetGameArbitraryFactory'],
  Interval: ['StepbetRound', 'DietbetRound'],
  OpUserNotificationSettings: [
    'StepbetNotificationSettings',
    'DietbetNotificationSettings',
  ],
  UserMembership: ['StepbetMembership', 'DietbetMembership'],
  UserGameStatus: ['FalkorUserGameStatus'],
  DietbetGameGoal: [
    'DietbetWeightLossGameGoal',
    'DietbetWeightMaintenanceGameGoal',
  ],
  OpPhoto: ['OpPhotoUser', 'OpPhotoWeighIn'],
  IntervalPlayerStatus: [
    'FalkorRoundPlayerStatus',
    'FalkorSubroundPlayerStatus',
  ],
  CreateMetricResult: [
    'QuitbetBreathMetric',
    'FalkorCaptionedPhotoMetric',
    'FalkorMediaMetric',
    'WorkoutMetric',
  ],
  FalkorMedia: ['CloudinaryVideo', 'CloudinaryImage'],
  ScheduledPostSpecPublishAtMilestone: [
    'ScheduledPostSpecPublishAtGameMilestone',
    'ScheduledPostSpecPublishAtRoundMilestone',
  ],
  FalkorMediaActivityConfig: ['FalkorMediaVideoActivityConfig'],
};
